module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-style/i1-6-589227b13364fce74628a60dbd7beb93.svg";